import { ageSla } from "@/lib/sla";

export const LeadAgeDot = ({ lead }) => {
  const s = ageSla(lead);
  if (!s) return null;
  return (
    <span
      data-testid={`age-dot-${s.level}`}
      title={s.label}
      className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full ${s.anim}`}
      style={{ backgroundColor: s.color, boxShadow: `0 0 6px ${s.color}` }}
    />
  );
};
